import { ArrowRight } from 'lucide-react';
import { FadeIn, ChapterHeading } from './Reveal';
import { PhoneMockup } from './PhoneMockup';
import { useLang } from '../i18n/LangContext';

export const BusinessSection = () => {
  const { t } = useLang();
  const BUSINESS_FEATURES = t.business.features;
  return (
  <section id="za-biznise" data-testid="business-section" className="bg-krug-mist py-24 md:py-32 relative overflow-hidden">
    <div className="absolute -top-24 -right-24 w-[420px] h-[420px] rounded-full bg-krug-gold/15 blur-[120px]" aria-hidden="true" />
    <div className="max-w-7xl mx-auto px-5 md:px-8 relative">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <FadeIn className="order-2 lg:order-1 relative flex justify-center">
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[420px] h-[420px] rounded-full bg-krug-gold/20 blur-[110px]" aria-hidden="true" />
          <div className="relative w-[250px] md:w-[290px] animate-float-soft" style={{ animationDelay: '1.4s' }}>
            <div className="phone-zoom-list rounded-[2.6rem]">
              <PhoneMockup src="/assets/screen-discover.webp" alt="KRUG aplikacija — pretraga biznisa iz dijaspore s ocjenama" glow="gold" />
            </div>
          </div>
        </FadeIn>

        <div className="order-1 lg:order-2">
          <ChapterHeading
            number="04"
            eyebrow={t.business.eyebrow}
            dark={false}
            title={t.business.title}
            copy={t.business.copy}
          />
          <FadeIn delay={0.2}>
            <ul data-testid="business-features" className="mt-9 flex flex-wrap gap-2.5">
              {BUSINESS_FEATURES.map((f) => (
                <li
                  key={f.label}
                  className="inline-flex items-center gap-2 rounded-full border border-krug-navy/10 bg-white px-4 py-2 text-xs md:text-sm font-semibold text-krug-navy shadow-sm"
                >
                  <f.icon size={15} className="text-krug-teal" />
                  {f.label}
                </li>
              ))}
            </ul>
            <div className="mt-10 rounded-3xl border border-krug-gold/40 bg-gradient-to-br from-krug-gold/10 to-transparent p-7 md:p-8">
              <p className="font-heading text-lg md:text-xl font-extrabold text-krug-navy">
                {t.business.boxTitle}
              </p>
              <a
                href="#waitlist"
                data-testid="business-cta"
                className="group mt-5 inline-flex items-center gap-2 rounded-full bg-krug-navy px-6 py-3 font-heading text-sm font-bold text-white hover:bg-krug-teal transition-colors duration-300"
              >
                {t.business.boxCta}
                <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
              </a>
            </div>
          </FadeIn>
        </div>
      </div>
    </div>
  </section>
  );
};
